import { atom } from 'jotai';

export const shippingLocationOpen = atom<boolean>(false);

export const openShippingLocationToggle = atom(null, (get, set, by) =>
  set(shippingLocationOpen, (value) => !value)
);
